import _get from 'hs-lodash/get';
const formatGoogleParticipant = participant => {
  const screenName = _get(participant.phoneUser, 'displayName') || _get(participant.signedinUser, 'displayName') || _get(participant.anonymousUser, 'displayName') || '';
  const participantId = participant.name.split('/').pop() || '1';
  const isAutoMapped = _get(participant, 'isAutoMapped', false);
  return {
    participantId,
    screenName,
    isAutoMapped,
    participantUUID: '',
    role: 'attendee'
  };
};
export const transformGoogleParticipants = googleParticipants => googleParticipants.map(formatGoogleParticipant);